import styled, { keyframes } from "styled-components";

const spin = keyframes`
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
`;

export const Container = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: left;
    width: 100%;
    height: 100%;
`;

export const Loader = styled.div`
    border: 8px solid #f3f3f3;
    border-top: 8px solid ${props => (props.$color)};
    border-radius: 50%;
    width: ${props => (props.$size)}px;
    height: ${props => (props.$size)}px;
    animation: ${spin} 1s linear infinite;
    margin-bottom: 10px;
`;